import { render, staticRenderFns } from "./settingsMode.vue?vue&type=template&id=d4c76e6e&"
import script from "./settingsMode.vue?vue&type=script&lang=js&"
export * from "./settingsMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports